export default "__VITE_ASSET__DHkJnmIp__"